import http from "../../../../../core/utils/apis/skillApi";

const SkillsReportsService = {
  getSkillLevelsFilteredByDepartment: (department, categories = []) =>
    http.get("/manager-skill-report/skill-levels/filter", {
      params: { department, categories: categories.join(",") },
    }),

  getSkillDistributionByCategory: (department) =>
    http.get("/manager-skill-report/skill-distribution-by-categories", {
      params: { department },
    }),
  getSkillAcquisitionProgress: (department) =>
    http.get("/manager-skill-report/skill-acquisition-progress", {
      params: { department },
    }),

  getTopSkillsByDepartment: (department) =>
    http.get("/manager-skill-report/top-skills", {
      params: { department },
    }),

  searchUserSkill: (skillName, department) =>
    http.get(`/manager-skill-report/search/${skillName}`, {
      params: { department },
    }),

  searchUsersByNameInDepartment: (query, department) =>
    http.get("/manager-skill-report/search-users", {
      params: { query, department },
    }),

  getSkillsByUser: (userId, department) =>
    http.get(`/manager-skill-report/${userId}/skills`, {
      params: { department },
    }),

  getManualRequestsStats: (department) =>
    http.get("/manager-skill-report/manual-requests-stats", {
      params: { department },
    }),

  getCertifiedRequestsStats: (department) =>
    http.get("/manager-skill-report/certified-requests-stats", {
      params: { department },
    }),
  getSkillCategories: () => http.get("/skills-reports/skill-categories"),
  searchUsersByName: (query) => http.get(`/users/search/${query}`),
  searchSkillsByName: (name) => http.get(`/skills/search/${name}`),
};

export default SkillsReportsService;
